import { render } from "./Customers.vue?vue&type=template&id=64a5ddea&scoped=true"
import script from "./Customers.vue?vue&type=script&lang=js"
export * from "./Customers.vue?vue&type=script&lang=js"

import "ag-grid-community/dist/styles/ag-theme-alpine.css?vue&type=style&index=0&lang=css"
import "ag-grid-community/dist/styles/ag-grid.css?vue&type=style&index=1&lang=css"
import "./Customers.vue?vue&type=style&index=2&id=64a5ddea&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2424817344/src/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a5ddea"],['__file',"src/views/Customers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64a5ddea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64a5ddea', __exports__)) {
    console.log('reload')
    api.reload('64a5ddea', __exports__)
  }
  
  module.hot.accept("./Customers.vue?vue&type=template&id=64a5ddea&scoped=true", () => {
    console.log('re-render')
    api.rerender('64a5ddea', render)
  })

}


export default __exports__